/*
 * assets/facturacion.js
 * Autofactura CFDI 4.0 (UnoKeeper). Controla sections/section-facturacion.liquid.
 *
 * - JavaScript simple (ES2017), sin dependencias ni build. Funciona con varias secciones en la misma página.
 * - Normaliza y valida los datos según el contrato (SPEC §1): RFC, razón social, régimen, CP, uso, etc.
 * - Filtra el régimen por el tipo de RFC (12 = moral, 13 = física) y el uso del CFDI por el régimen.
 * - Prellena el pedido y el correo desde el enlace de "Mis pedidos" (#pedido=&email=; también acepta
 *   ?pedido=&email= de enlaces anteriores) y los quita de la barra de direcciones con
 *   history.replaceState, para que no queden en el historial ni en las analíticas.
 * - Hace POST al webhook de Make con URLSearchParams y sin headers propios, así la petición CORS
 *   es "simple" y no hay preflight. Espera como máximo 120 s (data-timeout).
 * - Maneja la respuesta JSON de Make ({ok, code, message, folio, uuid, pedido}), el texto "Accepted",
 *   los errores 500, los errores de red o CORS y el tiempo de espera agotado.
 * - Nunca escribe datos personales en la consola (no hay console.* en este archivo).
 */
(function () {
  'use strict';

  if (window.ukFacturacion) {
    // Cada sección incluye este archivo: si ya corrió, solo inicializa las secciones nuevas.
    window.ukFacturacion.initAll(document);
    return;
  }

  var CONTACTO_DEFAULT = 'contacto@unokeeper.com';
  var TIMEOUT_DEFAULT = 120000;
  var AVISO_LENTO_MS = 20000;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var EMAIL_EN_TEXTO_RE = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g;
  // Régimen societario o de capital al final del nombre (el texto ya viene sin puntos ni comas).
  var SUFIJO_RE = /(^|\s)(S\s?A(\s?P\s?I|\s?B)?|S\s?A\s?S|S\s?DE\s?R\s?L(\s?MI)?|S\s?R\s?L|S\s?C(\s?[PL])?|A\s?C|S\s?P\s?R\s?DE\s?R\s?[LI]|S\s?EN\s?C(\s?POR\s?A)?|S\s?EN\s?N\s?C|S\s?N\s?C|I\s?A\s?P)(\s?DE\s?C\s?V)?$/;

  // Orden en que se validan y se enfocan los campos (igual que en el formulario).
  var CAMPOS = ['pedido', 'email', 'total', 'rfc', 'codigo_postal', 'razon_social', 'regimen_fiscal', 'uso_cfdi', 'tipo_tarjeta', 'email_factura', 'confirmo'];

  var M = {
    pedidoVacio: 'Escribe tu número de pedido.',
    pedidoFormato: 'Escribe solo el número de tu pedido, por ejemplo 50725.',
    emailVacio: 'Escribe el correo que usaste en tu compra.',
    emailVacioTienda: 'Escribe el correo donde quieres recibir tu factura.',
    totalVacio: 'Escribe el total de tu ticket.',
    tarjetaVacia: 'Elige si pagaste con tarjeta de crédito, de débito o sin tarjeta.',
    pistaTienda: 'Si diste tu correo al comprar en la tienda, desmarca «Compré en la tienda física» y escribe ese correo.',
    totalFormato: 'Escribe el total solo con números, por ejemplo 1359.00.',
    emailFormato: 'Revisa tu correo, parece que le falta algo (ejemplo: nombre@correo.com).',
    rfcVacio: 'Escribe tu RFC.',
    rfcLongitud: function (n) {
      return 'Tu RFC debe tener 13 caracteres si eres persona física o 12 si es una empresa (persona moral). El que escribiste tiene ' + n + '.';
    },
    rfcFormato: 'Revisa tu RFC: el formato no es válido. Cópialo tal como aparece en tu Constancia de Situación Fiscal.',
    rfcGenerico: 'Ese RFC genérico no aplica para facturas a tu nombre. Si eres extranjero escríbenos a {contacto}.',
    cpVacio: 'Escribe el código postal de tu domicilio fiscal.',
    cpFormato: 'El código postal debe tener 5 dígitos.',
    razonVacia: 'Escribe tu nombre o razón social tal como aparece en tu Constancia.',
    razonFormato: 'Tu nombre o razón social no puede tener más de 300 caracteres ni el símbolo «|».',
    razonSufijo: 'Parece que incluiste el régimen societario (por ejemplo «S.A. DE C.V.»). El SAT pide solo la razón social: por ejemplo «EMPRESA EJEMPLO» en lugar de «EMPRESA EJEMPLO S.A. DE C.V.». Revisa tu Constancia.',
    regimenVacio: 'Elige tu régimen fiscal.',
    regimenNoCorresponde: function (tipo) {
      return 'Ese régimen no corresponde a un RFC de ' + (tipo === 'moral' ? 'persona moral (12 caracteres)' : 'persona física (13 caracteres)') + '. Elige el que aparece en tu Constancia.';
    },
    regimenBorrado: function (tipo) {
      return 'Quitamos el régimen que habías elegido porque no corresponde a un RFC de ' + (tipo === 'moral' ? 'persona moral' : 'persona física') + '. Elige el tuyo de la lista.';
    },
    usoVacio: 'Elige el uso que le darás a tu factura.',
    usoNoCorresponde: 'Ese uso no está permitido para tu régimen fiscal. Elige otro de la lista.',
    usoUnico: function (uso) {
      return 'Con tu régimen fiscal el SAT solo permite el uso «' + uso + '», así que ya lo elegimos por ti.';
    },
    usoBorrado: 'Cambiaste de régimen y el uso que tenías ya no aplica. Elige uno de la lista.',
    emailFacturaFormato: 'Revisa este correo o déjalo vacío.',
    confirmar: 'Confirma que tus datos coinciden con tu Constancia de Situación Fiscal.',
    revisaCampos: 'Revisa los campos marcados.',
    enviando: 'Estamos generando tu factura. Normalmente tarda unos segundos, pero puede tardar hasta dos minutos; no cierres esta página.',
    enviandoLento: 'Seguimos trabajando en tu factura. Gracias por tu paciencia.',
    botonEnviando: 'Generando tu factura…',
    tituloError: 'No pudimos completar tu solicitud',
    tituloRecibido: '¡Recibimos tu solicitud!',
    exitoDefault: 'Generamos tu factura y la enviamos a tu correo. Revisa también la carpeta de spam.',
    descargarPdf: 'Descargar PDF',
    descargarXml: 'Descargar XML',
    enProceso: 'Tu factura está en proceso de timbrado. En unos minutos vuelve a enviar este formulario con los mismos datos y te la enviaremos (no se duplicará).',
    aceptado: 'Recibimos tu solicitud; si en unos minutos no te llega la factura escríbenos a {contacto}.',
    errorGenerico: 'No pudimos generar tu factura. Revisa tus datos e inténtalo de nuevo; si el problema sigue, escríbenos a {contacto}.',
    errorTecnico: 'Tuvimos un problema técnico y no pudimos generar tu factura. Inténtalo de nuevo en unos minutos; si el problema sigue, escríbenos a {contacto} con tu número de pedido.',
    errorRed: 'No pudimos conectarnos con nuestro sistema de facturación. Revisa tu conexión a internet e inténtalo de nuevo; si el problema sigue, escríbenos a {contacto} con tu número de pedido.',
    tituloTiempo: 'Tu solicitud está tardando más de lo normal',
    errorTiempo: 'Es posible que tu factura se siga generando. Revisa tu correo (también la carpeta de spam) en unos minutos. Si no te llega, vuelve a enviar este formulario con los mismos datos: es seguro y tu factura no se duplicará. Si el problema sigue, escríbenos a {contacto} con tu número de pedido.',
    honeypot: 'No pudimos enviar tu solicitud. Recarga la página e inténtalo de nuevo; si el problema sigue, escríbenos a {contacto}.',
    noDisponible: 'Por el momento la facturación en línea no está disponible. Escríbenos a {contacto} con tu número de pedido y tus datos fiscales, y con gusto te ayudamos.',
    volverFormulario: 'Volver al formulario',
    folio: 'Folio de tu factura: ',
    pedido: 'Pedido ',
    grupoFisica: 'Persona física (RFC de 13 caracteres)',
    grupoMoral: 'Persona moral o empresa (RFC de 12 caracteres)'
  };

  // Códigos de Make/Facturapi que señalan un campo del formulario (SPEC §2 y §6).
  var CODIGO_CAMPOS = {
    PEDIDO_INVALIDO: [['pedido', 'Revisa el número de pedido.']],
    PEDIDO_NO_ENCONTRADO: [['pedido', 'Revisa el número de pedido.'], ['email', 'Revisa que sea el correo de tu compra.']],
    EMAIL_INVALIDO: [['email', 'Revisa tu correo.']],
    TOTAL_INVALIDO: [['total', 'Revisa el total de tu ticket.']],
    TIPO_TARJETA_REQUERIDO: [['tipo_tarjeta', 'Elige crédito o débito.']],
    RFC_INVALIDO: [['rfc', 'Revisa tu RFC.']],
    RFC_GENERICO: [['rfc', 'Escribe tu propio RFC.']],
    SAT_RFC: [['rfc', 'Revisa tu RFC: debe ser igual al de tu Constancia.']],
    RAZON_SOCIAL_REQUERIDA: [['razon_social', 'Escribe tu nombre o razón social.']],
    SAT_NOMBRE: [['razon_social', 'Escríbelo exactamente como aparece en tu Constancia, sin «S.A. de C.V.».']],
    CP_INVALIDO: [['codigo_postal', 'Revisa el código postal.']],
    SAT_CP: [['codigo_postal', 'Debe ser el código postal de tu domicilio fiscal, como aparece en tu Constancia.']],
    REGIMEN_INVALIDO: [['regimen_fiscal', 'Elige tu régimen fiscal.']],
    REGIMEN_NO_CORRESPONDE_RFC: [['regimen_fiscal', 'Elige un régimen que corresponda a tu RFC.']],
    SAT_REGIMEN: [['regimen_fiscal', 'Elige el régimen que aparece en tu Constancia.']],
    USO_CFDI_INVALIDO: [['uso_cfdi', 'Elige el uso de tu factura.']],
    USO_NO_CORRESPONDE_REGIMEN: [['uso_cfdi', 'Elige un uso permitido para tu régimen.']]
  };
  // EN_PROCESO (202) y FACTURA_EN_PROCESO (409) no son errores: la factura se está timbrando.
  var CODIGOS_EXITO = { OK: 'ok', REENVIADA: 'ok', EN_PROCESO: 'pendiente', FACTURA_EN_PROCESO: 'pendiente' };

  function texto(v) {
    return v == null ? '' : String(v);
  }

  function normPedido(v) {
    return texto(v).trim().replace(/^(pedido|orden|order)\s*/i, '').replace(/[#\s]+/g, '');
  }

  // «$1,359.00» → «1359.00»: el servidor acepta el mismo formato.
  function normTotal(v) {
    return texto(v).replace(/[$\s,]+/g, '');
  }

  function normEmail(v) {
    return texto(v).trim();
  }

  function normRfc(v) {
    return texto(v).normalize('NFC').trim().replace(/[\s-]+/g, '').toUpperCase();
  }

  function normRazon(v) {
    return texto(v).normalize('NFC').toUpperCase().replace(/\s+/g, ' ').trim();
  }

  function normCp(v) {
    return texto(v).replace(/\D+/g, '');
  }

  function tieneSufijo(razon) {
    var limpio = razon.replace(/[.,]/g, ' ').replace(/\s+/g, ' ').trim();
    return limpio.length > 0 && SUFIJO_RE.test(limpio);
  }

  function sinPuntoFinal(s) {
    return texto(s).replace(/\.\s*$/, '');
  }

  function crear(tag, clase, contenido) {
    var el = document.createElement(tag);
    if (clase) el.className = clase;
    if (contenido != null) el.textContent = contenido;
    return el;
  }

  // ---------- Pedido y correo desde el enlace ----------
  // El botón de "Mis pedidos" abre /pages/facturacion#pedido=50725&email=... El fragmento (#) no se
  // manda al servidor ni en el encabezado Referer, y aquí lo quitamos de la barra de direcciones en
  // cuanto lo leemos. ?pedido=&email= (enlaces anteriores) también funciona y también se limpia.
  // Se lee una sola vez por carga, así todas las secciones de la página reciben los mismos datos.
  var datosEnlace = null;
  var instancias = [];

  function leerEnlace() {
    if (datosEnlace) return datosEnlace;
    datosEnlace = { pedido: '', email: '' };
    var loc = window.location;
    var qs;
    var hs = null;
    try {
      qs = new URLSearchParams(loc.search);
      var hash = loc.hash.replace(/^#/, '');
      if (hash.indexOf('=') > -1) hs = new URLSearchParams(hash);
    } catch (e) {
      return datosEnlace;
    }
    var valor = function (nombre) {
      return (hs && hs.get(nombre)) || qs.get(nombre) || '';
    };
    var pedido = normPedido(valor('pedido'));
    // Un "+" sin codificar llega como espacio, y un correo no lleva espacios.
    var email = normEmail(valor('email')).replace(/ /g, '+');
    if (/^\d{1,12}$/.test(pedido)) datosEnlace.pedido = pedido;
    if (email.length <= 254 && EMAIL_RE.test(email)) datosEnlace.email = email;

    var enQs = qs.has('pedido') || qs.has('email');
    var enHash = !!hs && (hs.has('pedido') || hs.has('email'));
    if (enQs || enHash) {
      try {
        // Solo se reescribe la parte que traía datos; lo demás de la URL queda igual.
        var search = loc.search;
        var fragmento = loc.hash;
        if (enQs) {
          qs.delete('pedido');
          qs.delete('email');
          search = qs.toString() ? '?' + qs.toString() : '';
        }
        if (enHash) {
          hs.delete('pedido');
          hs.delete('email');
          fragmento = hs.toString() ? '#' + hs.toString() : '';
        }
        window.history.replaceState(window.history.state, '', loc.pathname + search + fragmento);
      } catch (e) {
        /* sin cambios en la URL */
      }
    }
    return datosEnlace;
  }

  function Facturacion(root) {
    this.root = root;
    this.form = root.querySelector('[data-fx-form]');
    this.endpoint = texto(root.getAttribute('data-endpoint')).trim();
    this.contacto = texto(root.getAttribute('data-contact')).trim() || CONTACTO_DEFAULT;
    this.timeoutMs = parseInt(root.getAttribute('data-timeout'), 10) || TIMEOUT_DEFAULT;
    this.alerta = root.querySelector('[data-fx-alert]');
    this.estado = root.querySelector('[data-fx-status]');
    this.boton = root.querySelector('[data-fx-submit]');
    this.botonTexto = root.querySelector('[data-fx-submit-text]');
    this.botonLabel = texto(this.boton && this.boton.getAttribute('data-label')) || (this.botonTexto ? this.botonTexto.textContent : '');
    this.panel = root.querySelector('[data-fx-success]');
    this.otra = root.querySelector('[data-fx-again]');
    this.otraLabel = this.otra ? this.otra.textContent : '';
    this.tipoExito = '';
    this.ocupado = false;
    this.enviado = false; // hubo al menos un intento de envío: validar en vivo
    this.usoAutomatico = false;
    this.tipoRfcActual = null;
    this.errorServidor = {};

    var el = this.form.elements;
    this.campos = {};
    for (var i = 0; i < CAMPOS.length; i++) {
      this.campos[CAMPOS[i]] = el.namedItem(CAMPOS[i]);
    }
    this.tarjeta = el.namedItem('tipo_tarjeta');
    this.tienda = el.namedItem('tienda');
    this.textosTienda = root.querySelectorAll('[data-fx-tienda-text]');
    this.honeypot = el.namedItem('website');

    this.catalogo = this.leerCatalogo();
    if (!this.catalogo) {
      this.mostrarAlerta(M.noDisponible);
      return;
    }

    this.prellenar(leerEnlace(), false);
    this.actualizarTienda();
    this.actualizarRegimenes(true);
    this.actualizarUsos(true);
    this.enlazarEventos();

    if (this.endpoint && this.boton) {
      this.boton.disabled = false;
    }
    instancias.push(this);
  }

  Facturacion.prototype.leerCatalogo = function () {
    var nodo = this.root.querySelector('[data-fx-catalog]');
    try {
      var c = JSON.parse(nodo.textContent);
      var porClave = {};
      c.regimenes.forEach(function (r) {
        porClave[r.clave] = r;
      });
      c.porClave = porClave;
      c.rxMoral = new RegExp(c.rfc_moral);
      c.rxFisica = new RegExp(c.rfc_fisica);
      return c;
    } catch (e) {
      return null;
    }
  };

  // ---------- Prellenado con los datos del enlace (ver leerEnlace) ----------
  // El correo del enlace gana sobre el de la cuenta; el pedido no pisa lo que ya estaba escrito,
  // salvo que se abra otro enlace estando ya en la página (forzar).
  Facturacion.prototype.prellenar = function (datos, forzar) {
    var c = this.campos;
    if (datos.pedido && c.pedido && (forzar || !c.pedido.value)) c.pedido.value = datos.pedido;
    if (datos.email && c.email) c.email.value = datos.email;
  };

  // ---------- Catálogos: régimen por tipo de RFC y uso por régimen ----------
  Facturacion.prototype.tipoRfc = function () {
    var rfc = normRfc(this.campos.rfc.value);
    if (rfc.length === 12 && this.catalogo.rxMoral.test(rfc)) return 'moral';
    if (rfc.length === 13 && this.catalogo.rxFisica.test(rfc)) return 'fisica';
    return '';
  };

  Facturacion.prototype.actualizarRegimenes = function (inicial) {
    var tipo = this.tipoRfc();
    if (!inicial && tipo === this.tipoRfcActual) return;
    this.tipoRfcActual = tipo;

    var select = this.campos.regimen_fiscal;
    var actual = select.value;
    var regs = this.catalogo.regimenes;
    var grupos = [];
    if (tipo !== 'moral') {
      grupos.push({ label: M.grupoFisica, items: regs.filter(function (r) { return r.fisica; }) });
    }
    if (tipo !== 'fisica') {
      grupos.push({ label: M.grupoMoral, items: regs.filter(function (r) { return r.moral; }) });
    }

    var placeholder = select.querySelector('option[value=""]');
    while (select.firstChild) select.removeChild(select.firstChild);
    if (placeholder) select.appendChild(placeholder);

    var permitido = false;
    grupos.forEach(function (g) {
      var og = document.createElement('optgroup');
      og.label = g.label;
      g.items.forEach(function (r) {
        var op = document.createElement('option');
        op.value = r.clave;
        op.textContent = r.clave + ' – ' + r.descripcion;
        og.appendChild(op);
        if (r.clave === actual) permitido = true;
      });
      select.appendChild(og);
    });

    if (actual && permitido) {
      select.value = actual;
      this.aviso('regimen_fiscal', '');
    } else {
      select.value = '';
      if (actual) {
        this.aviso('regimen_fiscal', M.regimenBorrado(tipo));
        this.actualizarUsos(false);
      }
    }
    if (this.enviado || this.tieneError('regimen_fiscal')) this.validarCampo('regimen_fiscal');
  };

  Facturacion.prototype.actualizarUsos = function (inicial) {
    var select = this.campos.uso_cfdi;
    var actual = select.value;
    var reg = this.catalogo.porClave[this.campos.regimen_fiscal.value];
    var permitidos = reg ? reg.usos : this.catalogo.usos.map(function (u) { return u.clave; });

    var placeholder = select.querySelector('option[value=""]');
    while (select.firstChild) select.removeChild(select.firstChild);
    if (placeholder) select.appendChild(placeholder);

    var etiquetaUnica = '';
    this.catalogo.usos.forEach(function (u) {
      if (permitidos.indexOf(u.clave) === -1) return;
      var op = document.createElement('option');
      op.value = u.clave;
      op.textContent = u.clave + ' – ' + sinPuntoFinal(u.descripcion);
      select.appendChild(op);
      etiquetaUnica = u.clave + ' ' + sinPuntoFinal(u.descripcion);
    });

    if (permitidos.length === 1) {
      select.value = permitidos[0];
      this.usoAutomatico = true;
      this.aviso('uso_cfdi', M.usoUnico(etiquetaUnica));
    } else if (this.usoAutomatico) {
      // El uso lo habíamos elegido nosotros; con más opciones, que la persona elija.
      select.value = '';
      this.usoAutomatico = false;
      this.aviso('uso_cfdi', '');
    } else if (actual && permitidos.indexOf(actual) > -1) {
      select.value = actual;
      this.aviso('uso_cfdi', '');
    } else {
      select.value = '';
      this.aviso('uso_cfdi', actual && !inicial ? M.usoBorrado : '');
    }
    if (!inicial && (this.enviado || this.tieneError('uso_cfdi'))) this.validarCampo('uso_cfdi');
  };

  // ---------- Validación ----------
  Facturacion.prototype.normalizar = function (nombre) {
    var c = this.campos[nombre];
    if (!c || c.type === 'checkbox' || c.tagName === 'SELECT') return;
    var fn = { pedido: normPedido, email: normEmail, total: normTotal, email_factura: normEmail, rfc: normRfc, razon_social: normRazon, codigo_postal: normCp }[nombre];
    if (fn) {
      var v = fn(c.value);
      if (v !== c.value) c.value = v;
    }
  };

  Facturacion.prototype.mensajeError = function (nombre) {
    var c = this.campos[nombre];
    var cat = this.catalogo;
    var v;
    switch (nombre) {
      case 'pedido':
        v = normPedido(c.value);
        if (!v) return M.pedidoVacio;
        return /^\d{1,12}$/.test(v) ? '' : M.pedidoFormato;
      case 'email':
        v = normEmail(c.value);
        if (!v) return this.esTienda() ? M.emailVacioTienda : M.emailVacio;
        return v.length <= 254 && EMAIL_RE.test(v) ? '' : M.emailFormato;
      case 'total':
        if (!this.esTienda()) return '';
        v = normTotal(c.value);
        if (!v) return M.totalVacio;
        return /^\d{1,9}(\.\d{1,2})?$/.test(v) ? '' : M.totalFormato;
      case 'rfc':
        v = normRfc(c.value);
        if (!v) return M.rfcVacio;
        if (cat.rfc_genericos.indexOf(v) > -1) return this.conContacto(M.rfcGenerico);
        if (v.length !== 12 && v.length !== 13) return M.rfcLongitud(v.length);
        return (v.length === 12 ? cat.rxMoral : cat.rxFisica).test(v) ? '' : M.rfcFormato;
      case 'codigo_postal':
        v = normCp(c.value);
        if (!v) return M.cpVacio;
        return /^\d{5}$/.test(v) ? '' : M.cpFormato;
      case 'razon_social':
        v = normRazon(c.value);
        if (!v) return M.razonVacia;
        return v.length <= 300 && v.indexOf('|') === -1 ? '' : M.razonFormato;
      case 'regimen_fiscal':
        v = c.value;
        if (!v || !cat.porClave[v]) return M.regimenVacio;
        var tipo = this.tipoRfc();
        if (tipo && !cat.porClave[v][tipo]) return M.regimenNoCorresponde(tipo);
        return '';
      case 'uso_cfdi':
        v = c.value;
        if (!v) return M.usoVacio;
        var reg = cat.porClave[this.campos.regimen_fiscal.value];
        var usos = reg ? reg.usos : cat.usos.map(function (u) { return u.clave; });
        return usos.indexOf(v) > -1 ? '' : M.usoNoCorresponde;
      case 'tipo_tarjeta':
        return c.value ? '' : M.tarjetaVacia;
      case 'email_factura':
        v = normEmail(c.value);
        if (!v) return '';
        return v.length <= 254 && EMAIL_RE.test(v) ? '' : M.emailFacturaFormato;
      case 'confirmo':
        return c.checked ? '' : M.confirmar;
    }
    return '';
  };

  // Compra de mostrador: sin correo en el pedido, el total del ticket demuestra la compra.
  Facturacion.prototype.esTienda = function () {
    return !!(this.tienda && this.tienda.checked);
  };

  Facturacion.prototype.actualizarTienda = function () {
    var tienda = this.esTienda();
    var total = this.campos.total;
    if (total) {
      var caja = this.root.querySelector('[data-fx-field="total"]');
      if (caja) caja.hidden = !tienda;
      total.required = tienda;
      if (!tienda) this.marcar('total', '');
    }
    for (var i = 0; i < this.textosTienda.length; i++) {
      var t = this.textosTienda[i];
      if (!t.hasAttribute('data-fx-texto-linea')) t.setAttribute('data-fx-texto-linea', t.textContent);
      t.textContent = t.getAttribute(tienda ? 'data-fx-tienda-text' : 'data-fx-texto-linea');
    }
    if (this.enviado || this.tieneError('email')) this.validarCampo('email');
  };

  Facturacion.prototype.validarCampo = function (nombre) {
    if (!this.campos[nombre]) return true;
    var msg = this.mensajeError(nombre);
    this.marcar(nombre, msg);
    return !msg;
  };

  Facturacion.prototype.validarTodo = function () {
    var primero = null;
    for (var i = 0; i < CAMPOS.length; i++) {
      this.normalizar(CAMPOS[i]);
      if (!this.validarCampo(CAMPOS[i]) && !primero) primero = this.campos[CAMPOS[i]];
    }
    return primero;
  };

  Facturacion.prototype.caja = function (nombre, selector) {
    var campo = this.root.querySelector('[data-fx-field="' + nombre + '"]');
    return campo ? campo.querySelector(selector) : null;
  };

  Facturacion.prototype.marcar = function (nombre, msg) {
    var c = this.campos[nombre];
    var err = this.caja(nombre, '[data-fx-error]');
    if (msg) {
      c.setAttribute('aria-invalid', 'true');
    } else {
      c.removeAttribute('aria-invalid');
      delete this.errorServidor[nombre];
    }
    if (err) {
      err.textContent = msg || '';
      err.hidden = !msg;
    }
  };

  Facturacion.prototype.tieneError = function (nombre) {
    var c = this.campos[nombre];
    return !!c && c.getAttribute('aria-invalid') === 'true';
  };

  Facturacion.prototype.aviso = function (nombre, msg) {
    var av = this.caja(nombre, '[data-fx-warning]');
    if (av && av.textContent !== (msg || '')) av.textContent = msg || '';
  };

  Facturacion.prototype.revisarSufijo = function () {
    var v = normRazon(this.campos.razon_social.value);
    this.aviso('razon_social', v && tieneSufijo(v) ? M.razonSufijo : '');
  };

  // ---------- Eventos ----------
  Facturacion.prototype.enlazarEventos = function () {
    var self = this;
    var form = this.form;

    form.addEventListener('input', function (e) {
      var nombre = e.target && e.target.name;
      if (!nombre || !self.campos[nombre]) return;
      if (self.errorServidor[nombre]) {
        self.marcar(nombre, '');
      } else if (self.tieneError(nombre)) {
        self.validarCampo(nombre); // quita el error en cuanto se corrige
      }
      if (nombre === 'rfc') self.actualizarRegimenes(false);
      if (nombre === 'razon_social' && self.caja('razon_social', '[data-fx-warning]').textContent) self.revisarSufijo();
    });

    form.addEventListener('change', function (e) {
      var nombre = e.target && e.target.name;
      if (nombre === 'regimen_fiscal') {
        self.aviso('regimen_fiscal', '');
        self.actualizarUsos(false);
      }
      if (nombre === 'tienda') self.actualizarTienda();
      if (nombre === 'uso_cfdi') {
        self.usoAutomatico = false;
        self.aviso('uso_cfdi', '');
      }
      if (nombre && self.campos[nombre] && (e.target.tagName === 'SELECT' || e.target.type === 'checkbox')) {
        if (self.enviado || self.tieneError(nombre)) self.validarCampo(nombre);
      }
    });

    // Al salir de un campo de texto: normalizar y, si ya tiene algo escrito, validar.
    form.addEventListener('focusout', function (e) {
      var t = e.target;
      var nombre = t && t.name;
      if (!nombre || !self.campos[nombre] || t.tagName !== 'INPUT' || t.type === 'checkbox') return;
      self.normalizar(nombre);
      if (nombre === 'rfc') self.actualizarRegimenes(false);
      if (nombre === 'razon_social') self.revisarSufijo();
      if (t.value || self.enviado) self.validarCampo(nombre);
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.enviar();
    });

    if (this.otra) {
      this.otra.addEventListener('click', function () {
        self.reiniciar();
      });
    }
  };

  // ---------- Envío ----------
  Facturacion.prototype.parametros = function () {
    var c = this.campos;
    var p = new URLSearchParams();
    p.append('pedido', normPedido(c.pedido.value));
    p.append('email', normEmail(c.email.value));
    if (this.esTienda() && c.total) p.append('total', normTotal(c.total.value));
    p.append('rfc', normRfc(c.rfc.value));
    p.append('razon_social', normRazon(c.razon_social.value));
    p.append('regimen_fiscal', c.regimen_fiscal.value);
    p.append('codigo_postal', normCp(c.codigo_postal.value));
    p.append('uso_cfdi', c.uso_cfdi.value);
    p.append('tipo_tarjeta', this.tarjeta ? this.tarjeta.value : '');
    p.append('email_factura', normEmail(c.email_factura.value));
    p.append('website', this.honeypot ? this.honeypot.value : '');
    p.append('origen', 'tema');
    return p;
  };

  Facturacion.prototype.enviar = function () {
    var self = this;
    if (this.ocupado) return;
    this.ocultarAlerta();

    if (!this.endpoint) {
      this.mostrarAlerta(M.noDisponible);
      return;
    }

    this.enviado = true;
    var primero = this.validarTodo();
    if (primero) {
      this.setEstado(M.revisaCampos);
      primero.focus();
      return;
    }

    // Honeypot: una persona no ve este campo. Si trae algo, no mandamos nada.
    if (this.honeypot && this.honeypot.value) {
      this.mostrarAlerta(M.honeypot);
      return;
    }

    var params = this.parametros();
    var terminado = false;
    var controller = typeof AbortController === 'function' ? new AbortController() : null;

    this.setOcupado(true);
    this.setEstado(M.enviando);
    var lento = window.setTimeout(function () {
      if (!terminado) self.setEstado(M.enviandoLento);
    }, AVISO_LENTO_MS);
    var limite = window.setTimeout(function () {
      if (terminado) return;
      terminado = true;
      if (controller) controller.abort();
      self.terminar(lento);
      self.mostrarAlerta(M.errorTiempo, M.tituloTiempo, true);
    }, this.timeoutMs);

    var opciones = {
      method: 'POST',
      body: params,
      mode: 'cors',
      credentials: 'omit',
      referrerPolicy: 'strict-origin-when-cross-origin'
    };
    if (controller) opciones.signal = controller.signal;

    fetch(this.endpoint, opciones)
      .then(function (res) {
        return res.text().then(function (cuerpo) {
          return { status: res.status, cuerpo: cuerpo };
        });
      })
      .then(
        function (r) {
          if (terminado) return;
          terminado = true;
          window.clearTimeout(limite);
          self.terminar(lento);
          self.procesarRespuesta(r.status, r.cuerpo);
        },
        function () {
          if (terminado) return;
          terminado = true;
          window.clearTimeout(limite);
          self.terminar(lento);
          self.mostrarAlerta(M.errorRed);
        }
      );
  };

  Facturacion.prototype.terminar = function (lento) {
    window.clearTimeout(lento);
    this.setOcupado(false);
    this.setEstado('');
  };

  Facturacion.prototype.procesarRespuesta = function (status, cuerpo) {
    var data = null;
    var limpio = texto(cuerpo).trim();
    if (limpio.charAt(0) === '{') {
      try {
        data = JSON.parse(limpio);
      } catch (e) {
        data = null;
      }
    }

    if (data && typeof data === 'object') {
      var code = texto(data.code).toUpperCase();
      if (status === 202 || CODIGOS_EXITO[code] === 'pendiente') {
        this.mostrarExito(data, 'pendiente');
      } else if (data.ok === true || CODIGOS_EXITO[code] === 'ok') {
        this.mostrarExito(data, 'ok');
      } else {
        this.mostrarErrorServidor(code, data.message, status);
      }
      return;
    }

    if (status >= 200 && status < 300) {
      // "Accepted": Make recibió la solicitud pero no respondió el escenario (apagado o en cola).
      this.mostrarExito(null, 'aceptado');
      return;
    }

    // 500 "Scenario failed to complete.", 4xx de Make sin JSON, etc.
    this.mostrarAlerta(M.errorTecnico);
  };

  Facturacion.prototype.mostrarErrorServidor = function (code, mensaje, status) {
    var msg = texto(mensaje).trim().slice(0, 800);
    if (!msg) msg = status >= 500 ? M.errorTecnico : M.errorGenerico;
    var tienda = code === 'PEDIDO_NO_ENCONTRADO' && this.esTienda();
    var campos = tienda
      ? [['pedido', 'Revisa el número de pedido.'], ['total', 'Revisa el total de tu ticket.']]
      : CODIGO_CAMPOS[code] || [];
    if (tienda) msg += ' ' + M.pistaTienda;
    for (var i = 0; i < campos.length; i++) {
      if (this.campos[campos[i][0]]) {
        this.marcar(campos[i][0], campos[i][1]);
        this.errorServidor[campos[i][0]] = true;
      }
    }
    this.mostrarAlerta(msg);
  };

  // ---------- Interfaz ----------
  Facturacion.prototype.conContacto = function (msg) {
    return texto(msg).replace(/\{contacto\}/g, this.contacto);
  };

  // Escribe el texto y convierte los correos en enlaces mailto (sin innerHTML).
  Facturacion.prototype.escribir = function (el, msg) {
    var t = this.conContacto(msg);
    var ultimo = 0;
    var m;
    el.textContent = '';
    EMAIL_EN_TEXTO_RE.lastIndex = 0;
    while ((m = EMAIL_EN_TEXTO_RE.exec(t))) {
      if (m.index > ultimo) el.appendChild(document.createTextNode(t.slice(ultimo, m.index)));
      var a = crear('a', '', m[0]);
      a.href = 'mailto:' + m[0];
      el.appendChild(a);
      ultimo = m.index + m[0].length;
    }
    if (ultimo < t.length) el.appendChild(document.createTextNode(t.slice(ultimo)));
  };

  // neutral: aviso sin tono de error (tiempo agotado: la factura puede seguir generándose).
  Facturacion.prototype.mostrarAlerta = function (msg, titulo, neutral) {
    var a = this.alerta;
    if (!a) return;
    a.textContent = '';
    a.classList.toggle('facturacion__box--notice', !!neutral);
    a.appendChild(crear('p', 'facturacion__box-title', titulo || M.tituloError));
    var p = crear('p');
    this.escribir(p, msg);
    a.appendChild(p);
    a.hidden = false;
    a.focus();
  };

  Facturacion.prototype.ocultarAlerta = function () {
    if (!this.alerta) return;
    this.alerta.hidden = true;
    this.alerta.textContent = '';
  };

  Facturacion.prototype.setEstado = function (msg) {
    if (this.estado) this.estado.textContent = msg || '';
  };

  Facturacion.prototype.setOcupado = function (on) {
    this.ocupado = on;
    // Mientras se timbra no se puede editar: lo enviado ya se tomó y un cambio no llegaría (auditoría H13).
    var grupos = this.form.querySelectorAll('fieldset');
    for (var i = 0; i < grupos.length; i++) grupos[i].disabled = on;
    this.form.classList.toggle('is-busy', on);
    this.form.setAttribute('aria-busy', on ? 'true' : 'false');
    if (this.boton) {
      this.boton.classList.toggle('is-loading', on);
      this.boton.setAttribute('aria-disabled', on ? 'true' : 'false');
    }
    if (this.botonTexto) this.botonTexto.textContent = on ? M.botonEnviando : this.botonLabel;
  };

  Facturacion.prototype.mostrarExito = function (data, tipo) {
    var panel = this.panel;
    if (!panel) return;
    data = data || {};
    var titulo = panel.querySelector('[data-fx-success-title]');
    var mensaje = panel.querySelector('[data-fx-success-message]');
    var folio = panel.querySelector('[data-fx-success-folio]');
    var defecto = { ok: M.exitoDefault, pendiente: M.enProceso, aceptado: M.aceptado }[tipo];

    if (titulo) {
      titulo.textContent = tipo === 'ok' ? panel.getAttribute('data-default-title') || '¡Tu factura va en camino!' : M.tituloRecibido;
    }
    if (mensaje) this.escribir(mensaje, texto(data.message).trim().slice(0, 800) || defecto);
    if (folio) {
      folio.textContent = '';
      var f = texto(data.folio).trim();
      var ped = texto(data.pedido).trim();
      if (f || ped) {
        if (ped) folio.appendChild(document.createTextNode(M.pedido + ped + (f ? ' · ' : '')));
        if (f) {
          folio.appendChild(document.createTextNode(M.folio));
          folio.appendChild(crear('strong', '', f));
        }
      }
      folio.hidden = !(f || ped);
    }
    this.mostrarDescargas(tipo === 'ok' ? data.descargas : null);
    panel.classList.toggle('facturacion__panel--pending', tipo !== 'ok');
    this.tipoExito = tipo;
    if (this.otra) this.otra.textContent = tipo === 'ok' ? this.otraLabel : M.volverFormulario;

    this.ocultarAlerta();
    this.form.hidden = true;
    panel.hidden = false;
    panel.focus();
  };

  // Botones para bajar el PDF y el XML de inmediato. Solo enlaces del mismo servicio que timbró.
  Facturacion.prototype.mostrarDescargas = function (descargas) {
    var caja = this.panel && this.panel.querySelector('[data-fx-success-downloads]');
    if (!caja) return;
    caja.textContent = '';
    var origen = '';
    try {
      origen = new URL(this.endpoint).origin + '/';
    } catch (e) {
      origen = '';
    }
    var formatos = [['pdf', M.descargarPdf], ['xml', M.descargarXml]];
    for (var i = 0; i < formatos.length; i++) {
      var url = descargas && typeof descargas === 'object' ? texto(descargas[formatos[i][0]]) : '';
      if (!origen || url.indexOf(origen) !== 0) continue;
      var a = crear('a', caja.getAttribute('data-btn-class') || 'btn', formatos[i][1]);
      a.href = url;
      a.rel = 'noopener';
      caja.appendChild(a);
    }
    caja.hidden = !caja.childNodes.length;
  };

  Facturacion.prototype.reiniciar = function () {
    if (this.panel) this.panel.hidden = true;
    this.form.hidden = false;
    this.ocultarAlerta();
    this.setEstado('');
    // Con la factura lista se borra el pedido para facturar otro. Si quedó en proceso se conservan
    // todos los datos para volver a enviarlos igual en unos minutos (no se duplica la factura).
    if (this.tipoExito === 'ok') {
      this.campos.pedido.value = '';
      this.marcar('pedido', '');
      if (this.campos.total) {
        this.campos.total.value = '';
        this.marcar('total', '');
      }
    }
    this.enviado = false;
    this.campos.pedido.focus();
  };

  // ---------- Arranque ----------
  function init(root) {
    if (!root || root.hasAttribute('data-fx-ready')) return;
    root.setAttribute('data-fx-ready', '');
    try {
      new Facturacion(root);
    } catch (e) {
      root.removeAttribute('data-fx-ready');
    }
  }

  function initAll(scope) {
    var nodos = (scope || document).querySelectorAll('[data-facturacion]');
    for (var i = 0; i < nodos.length; i++) init(nodos[i]);
  }

  window.ukFacturacion = { initAll: initAll };

  // Limpia la URL cuanto antes, aunque alguna sección no llegue a iniciar.
  leerEnlace();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Editor de temas: la sección se vuelve a renderizar al cambiar ajustes.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  // Si abres otro enlace #pedido=&email= estando ya en esta página, el navegador no la recarga:
  // se leen los datos nuevos, se limpian de la URL y se llevan al formulario.
  window.addEventListener('hashchange', function () {
    if (!/[#&](pedido|email)=/.test(window.location.hash)) return;
    datosEnlace = null;
    var datos = leerEnlace();
    instancias = instancias.filter(function (f) {
      return document.documentElement.contains(f.root);
    });
    instancias.forEach(function (f) {
      if (f.ocupado) return;
      if (f.panel && !f.panel.hidden) f.reiniciar(); // estaba el mensaje de éxito: regresa al formulario
      f.prellenar(datos, true);
    });
  });
})();
